import React, { useContext, useEffect, useRef, useState } from "react";
import { RecadastramentoContext } from "@contexts";
import { Alert, Box, Button, Col, ComboBox, Form, Input, Row } from "@intech/web-ui";
import { PlanoService, RecadastramentoService } from "@services";
import { DependenteEntidade, PlanoVinculadoEntidade, SexoEntidade, WebRecadParticipanteDadosEntidade } from "@entidades";
import { LoadingComponent } from "@components";
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaCheck, FaPlus, FaTimes } from "react-icons/fa";
import { DMN_IND_OPERACAO_BEN_RECAD, DMN_PLANO } from "@domains";
import moment from "moment";

interface IProps {
  avancar: (PassoEspecifico?: number | null) => Promise<void>;
  voltar: (PassoEspecifico?: number | null) => Promise<void>;
}

export const Passo7: React.FC<IProps> = ({
  avancar,
  voltar
}) => {
  const context = useContext(RecadastramentoContext);
  const isMountedRef = useRef(true);
  const form = useRef<Form>(null);

  const [TituloBoxAcao, setTituloBoxAcao] = useState<string>("");
  const [TituloBotaoBoxAcao, setTituloBotaoBoxAcao] = useState<string>("");
  const [VisibilidadeBoxAcao, setVisibilidadeBoxAcao] = useState<boolean>(false);
  const [Acao, setAcao] = useState<string>("");

  const [DepAtivo, setDepAtivo] = useState<DependenteEntidade>(null);

  const [CdGrauParentesco, setCdGrauParentesco] = useState<string>("");
  const [GrauParentesco, setGrauParentesco] = useState<string>("");
  const [Nome, setNome] = useState<string>("");
  const [DataNascimento, setDataNascimento] = useState<string>("");
  const [Sexo, setSexo] = useState<string>("");
  const [Cpf, setCpf] = useState<string>("");
  const [NumSeqDep, setNumSeqDep] = useState<number>(0);

  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>(null);
  const [ListaSexo, setListaSexo] = useState<SexoEntidade[]>([]);
  const [ListaDependente, setListaDependente] = useState<DependenteEntidade[]>([]);
  const [DadosOriginais, setDadosOriginais] = useState<WebRecadParticipanteDadosEntidade>(null);

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");
  const [ErroForm, setErroForm] = useState<string>("");

  const OpcoesGrauParentesco = [
    {
      Value: "03",
      Name: "COMPANHEIRA",
    },
    {
      Value: "04",
      Name: "COMPANHEIRO",
    },
    {
      Value: "05",
      Name: "FILHA",
    },
    {
      Value: "07",
      Name: "FILHO",
    },
    {
      Value: "06",
      Name: "FILHO/FILHA INVALIDA",
    },
    {
      Value: "13",
      Name: "MAE",
    },
    {
      Value: "14",
      Name: "PAI",
    },
  ];

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (!isMountedRef.current)
          return;

        // const dados = await context.buscarDadosParticipante();
        const dadosOriginais = await context.buscarDadosOriginais();

        const ListaSexo = await RecadastramentoService.BuscarListaSexo();

        const Planos = await PlanoService.Buscar();

        let listaDependentes = await context.buscarListaDependentes();

        if (listaDependentes.length === 0) {
          const listaDepSistema = await RecadastramentoService.BuscarBeneficiarios(Planos[0].CD_PLANO);
          listaDependentes = listaDepSistema;
        }

        setDadosOriginais(dadosOriginais);
        setListaSexo(ListaSexo);
        setListaDependente(listaDependentes);
        setPlano(Planos[0]);
      } catch (e) {
        const error: any = e;
        const messsage = error.response ? error.response.data : error;
        setErro(messsage);
      } finally {
        setLoading(false);
      }
    })();
  }, []);


  async function handleVoltar() {
    form?.current?.clear();
    setErroForm("");
    try {
      context.salvarListaDependentes(ListaDependente);
      voltar();
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErroForm(messsage);
    }
  }

  async function handleAvancar() {
    setErroForm("");
    try {

      const dependentesSemExcluidos = ListaDependente.filter((dep) => dep.IND_OPERACAO !== DMN_IND_OPERACAO_BEN_RECAD.EXCLUIR);

      const semCPF = dependentesSemExcluidos.some((dep) => dep.CPF === null || dep.CPF === undefined || dep.CPF === "");

      if (semCPF) {
        setErroForm("É obrigatório informar o CPF de todos os dependentes.");
        return false;
      }

      const CPFs = dependentesSemExcluidos.map((x) => x.CPF);

      const CPFRepetido = new Set(CPFs).size !== CPFs.length;

      if (CPFRepetido) {
        setErroForm("Os CPFs dos Dependentes não podem ser iguais.");
        return false;
      }

      context.salvarListaDependentes(ListaDependente);
      avancar();
    } catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErroForm(messsage);
    }
  };

  function Remover(dep: DependenteEntidade) {
    if (window.confirm("Deseja realmente remover o beneficiário selecionado? A remoção será efetivada apenas após análise da Faelce.")) {
      dep.IND_OPERACAO = DMN_IND_OPERACAO_BEN_RECAD.EXCLUIR;
      const ListaAtualizada = ListaDependente.filter((item) => item !== dep);

      setListaDependente([...ListaAtualizada, dep]);
    }
  };

  async function Incluir() {
    try {
      form?.current.clear();
      setErroForm("");

      if (form?.current?.validate()) {
        await RecadastramentoService.ValidarCpf(Cpf);

        // const gp = OpcoesGrauParentesco.filter((item) => item.Value === GrauParentesco);

        // if (gp.length === 0) {
        //   setErroForm("Grau de Parentesco obrigatório.")
        //   return;
        // }

        let novoDep = new DependenteEntidade();
        novoDep.DS_GRAU_PARENTESCO = GrauParentesco;
        novoDep.CD_GRAU_PARENTESCO = CdGrauParentesco;
        novoDep.NOME_DEP = Nome;
        novoDep.DT_NASC_DEP = moment(DataNascimento, "DD/MM/YYYY").toDate();
        novoDep.SEXO_DEP = Sexo;
        novoDep.CPF = Cpf;
        novoDep.CD_FUNDACAO = DadosOriginais.CD_FUNDACAO;
        novoDep.CD_PLANO = Plano.CD_PLANO;
        novoDep.NUM_INSCRICAO = DadosOriginais.NUM_INSCRICAO;
        novoDep.NUM_SEQ_DEP = 0;
        novoDep.IND_OPERACAO = DMN_IND_OPERACAO_BEN_RECAD.INCLUIR;

        const ListaAtualizada = [...ListaDependente, novoDep];

        setListaDependente(ListaAtualizada);

        setVisibilidadeBoxAcao(false);

        LimparCampos();
      }
    } catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErroForm(messsage);
    }
  };

  async function Editar() {
    try {
      form?.current.clear();
      setErroForm("");

      if (form?.current?.validate()) {
        await RecadastramentoService.ValidarCpf(Cpf);

        // const gp = OpcoesGrauParentesco.filter((item) => item.Value === GrauParentesco);

        // if (gp.length === 0) {
        //   setErroForm("Grau de Parentesco obrigatório.")
        //   return;
        // }

        let novoDep = DepAtivo;
        novoDep.DS_GRAU_PARENTESCO = GrauParentesco;
        novoDep.CD_GRAU_PARENTESCO = CdGrauParentesco;
        novoDep.NOME_DEP = Nome;
        novoDep.DT_NASC_DEP = moment(DataNascimento, "DD/MM/YYYY").toDate();
        novoDep.SEXO_DEP = Sexo;
        novoDep.CPF = Cpf;
        novoDep.NUM_SEQ_DEP = NumSeqDep;
        novoDep.IND_OPERACAO = DMN_IND_OPERACAO_BEN_RECAD.ALTERAR;
        novoDep.CD_PLANO = Plano.CD_PLANO;

        const ListaAtualizada = ListaDependente.filter((item) => item !== novoDep);

        setListaDependente([...ListaAtualizada, novoDep]);

        setVisibilidadeBoxAcao(false);

        LimparCampos();
      }
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErroForm(messsage);
    }
  };

  function PrepararIncluir() {
    setTituloBoxAcao("Inclusão Beneficiário de Pensão");
    setTituloBotaoBoxAcao("Incluir");
    setVisibilidadeBoxAcao(true);
    setAcao(DMN_IND_OPERACAO_BEN_RECAD.INCLUIR);

    LimparCampos();
  }

  function PrepararEditar(dep: DependenteEntidade) {
    setTituloBoxAcao("Edição Beneficiário de Pensão");
    setTituloBotaoBoxAcao("Gravar");
    setVisibilidadeBoxAcao(true);
    setDepAtivo(dep);
    setAcao(DMN_IND_OPERACAO_BEN_RECAD.ALTERAR);

    // const sexo = ListaSexo.filter(x => x.CD_SEXO === dep.SEXO_DEP);

    setCdGrauParentesco(dep.CD_GRAU_PARENTESCO);
    setGrauParentesco(dep.DS_GRAU_PARENTESCO);
    setNome(dep.NOME_DEP);
    setDataNascimento(moment(dep.DT_NASC_DEP, "DD/MM/YYYY").format("DD/MM/YYYY"));
    setSexo(dep.SEXO_DEP);
    setCpf(dep.CPF);
    setNumSeqDep(dep.NUM_SEQ_DEP);
  };

  function Confirmar() {
    try {
      switch (Acao) {
        case DMN_IND_OPERACAO_BEN_RECAD.ALTERAR:
          Editar();
          break;
        case DMN_IND_OPERACAO_BEN_RECAD.INCLUIR:
          Incluir();
          break;
        default:
          setErro(`Ação "${Acao}" não cadastrada no sistema. Favor contatar a Fundação.`);
      }
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErro(messsage);
    }
  }

  function Cancelar() {
    setTituloBoxAcao("");
    setTituloBotaoBoxAcao("");
    setVisibilidadeBoxAcao(false);

    LimparCampos();
  }

  function LimparCampos() {
    setDepAtivo(null);
    setCdGrauParentesco("");
    setGrauParentesco("");
    setNome("");
    setDataNascimento("");
    setSexo("");
    setCpf("");
    setNumSeqDep(0);
  }

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={'danger'}>{Erro}</Alert>}

      {!Loading && !Erro && (
        <>
          <Box>
            <ol>
              {"A legislação em vigor enumera os dependentes de segurado do INSS em ordem de prioridade conforme as 3 classes abaixo:"}
              <li>
                {"Classe 1"}
                <br />
                {"Cônjuge ou companheira (o), inclusive homoafetivo;"}
                <br />
                {"Filho não emancipado ou equiparado, de qualquer condição, menor de 21 anos de idade; ou"}
                <br />
                {"Filho com qualquer idade, com invalidez ou deficiência intelectual ou mental que o torne absoluta ou relativamente incapaz, assim declarado pela justiça."}
              </li>
              <li>
                {"Classe 2"}
                <br />
                {"Pais"}
              </li>
              <li>
                {"Classe 3"}
                <br />
                {"Irmão não emancipado, de qualquer condição, menor de 21 anos; ou,"}
                <br />
                {"Irmão de qualquer idade, com invalidez ou deficiência intelectual ou mental que o torne absoluta ou relativamente incapaz, assim declarado pela justiça."}
              </li>
            </ol>
            <ul>
              {"Importante!"}
              <li>
                {"Para concessão do benefício será observada a ordem de prioridade das classes. A classe anterior, exclui a seguinte, ou seja, se por exemplo a pessoa falecida tinha cônjuge, automaticamente os pais e o irmão estão excluídos."}
              </li>
            </ul>
            {Plano && Plano.CD_PLANO === DMN_PLANO.CONTRIBUICAO_DEFINIDA && <>
              <Alert type={"info"}>
                {"Nos termos do art. 14 do Regulamento do Plano, são beneficiários do participante os seus dependentes que constarem da carta de concessão da pensão por morte da Previdência Social e, na inexistência destes, a(s) pessoa(s) designada(s) pelo participante, bem como, na inexistência destas últimas, os seus herdeiros legais, observado que o pagamento de benefícios a beneficiários que não constem do rol de beneficiários incluídos na carta de concessão da pensão por morte da Previdência Social exigirá a apresentação de alvará ou decisão judicial determinando a quem deve ser realizado o pagamento."}
              </Alert>
              <span>{"Fonte: https://www.gov.br/pt-br/servicos/solicitar-pensao-por-morte-urbana"}</span></>}
            <Alert type={"info"}>{"Para informar o CPF do(s) dependente(s), clique no botão Editar, digite o número e, em seguida, clique no botão \"Gravar\""}</Alert>
          </Box>

          {ListaDependente.length > 0 && <>
            <table className={"table table-responsive"}>
              <thead>
                <tr>
                  <th className={"text-center"} style={{ width: "150" }}>Grau de Parentesco</th>
                  <th style={{ width: "250" }}>Nome</th>
                  <th className={"text-center"} style={{ width: "150" }}>Data de Nascimento</th>
                  <th className={"text-center"}>Sexo</th>
                  <th className={"text-center"}>CPF</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>{ListaDependente.map((dep: DependenteEntidade, index: number) => {
                const cor = dep.IND_OPERACAO === DMN_IND_OPERACAO_BEN_RECAD.EXCLUIR ? "text-danger" : index % 2 === 0 ? "table-active" : "";
                return (
                  <tr className={cor} key={index}>
                    <td className={"text-center"}>{dep.DS_GRAU_PARENTESCO}</td>
                    <td>{dep.NOME_DEP}</td>
                    <td className={"text-center"}>{dep.DT_NASC_DEP ? moment(dep.DT_NASC_DEP, "DD/MM/YYYY").format("DD/MM/YYYY") : ""}</td>
                    <td className={"text-center"}>{dep.SEXO_DEP === "F" ? "FEMININO" : "MASCULINO"}</td>
                    <td className={"text-center"}>{dep.CPF}</td>
                    <td>
                      <Button
                        title={"Editar"}
                        size={"mini"}
                        type={"primary"}
                        onClick={() => PrepararEditar(dep)}
                      />
                    </td>
                    <td>
                      <Button
                        title={"Excluir"}
                        size={"mini"}
                        type={"danger"}
                        onClick={() => Remover(dep)}
                      />
                    </td>
                  </tr>
                );
              })}</tbody>
            </table>
          </>}

          {ListaDependente.length === 0 && <Alert type={"info"}>{"Nenhum beneficiário cadastrado."}</Alert>}

          {/* {!VisibilidadeBoxAcao &&
            <Row>
              <Col>
                <Button
                  className={"mb-2"}
                  type={"success"}
                  title={"Incluir Beneficiário"}
                  onClick={PrepararIncluir}
                  icon={<FaPlus />}
                  usesLoading
                />
              </Col>
            </Row>} */}

          {VisibilidadeBoxAcao && <>
            <Box title={TituloBoxAcao}>
              <Form ref={form}>
                {/* <ComboBox
                  data={OpcoesGrauParentesco}
                  title={"* Grau de Parentesco"}
                  value={GrauParentesco}
                  onChange={setGrauParentesco}
                  memberName={"Name"}
                  memberValue={"Value"}
                  emptyText={"Escolha um Grau de Parentesco"}
                /> */}

                <Input
                  value={GrauParentesco}
                  // onChange={setGrauParentesco}
                  title={"Grau de Parentesco"}
                  // max={40}
                  readonly
                />

                <Input
                  value={Nome}
                  // onChange={setNome}
                  title={"Nome do Dependente"}
                  max={40}
                  readonly
                />

                <Input
                  value={DataNascimento}
                  // onChange={setDataNascimento}
                  title={"Data de Nascimento"}
                  type={"date"}
                  readonly
                />
                {/* 
                <ComboBox
                  data={ListaSexo}
                  title={"* Sexo"}
                  value={Sexo}
                  onChange={setSexo}
                  memberName={"DS_SEXO"}
                  memberValue={"CD_SEXO"}
                  emptyText={"Escolha um Sexo"}
                /> */}

                <Input
                  value={Sexo}
                  // onChange={setSexo}
                  title={"Sexo"}
                  readonly
                />

                <Input
                  value={Cpf}
                  onChange={setCpf}
                  title={"CPF"}
                  mask={"cpf"}
                  required
                />

                <Alert formAlert type={"danger"} />
                <Alert type={"danger"}>{ErroForm}</Alert>

                <Row>
                  <Col>
                    <Button
                      type={"danger"}
                      title={"Cancelar"}
                      icon={<FaTimes />}
                      onClick={Cancelar}
                      block
                    />
                  </Col>

                  <Col>
                    <Button
                      type={"primary"}
                      title={TituloBotaoBoxAcao}
                      icon={<FaCheck />}
                      onClick={Confirmar}
                      submit
                      block
                    />
                  </Col>
                </Row>
              </Form>
            </Box>
          </>}

          {!VisibilidadeBoxAcao &&
            <Alert type={"danger"}>{ErroForm}</Alert>
          }

          <Row>
            <Col>
              <Button
                type={"secondary"}
                title={"Voltar"}
                icon={<FaAngleDoubleLeft />}
                onClick={handleVoltar}
                loadingText={"Voltando..."}
                usesLoading
                block
                iconRight
              />
            </Col>

            <Col>
              <Button
                type={"primary"}
                title={"Continuar"}
                icon={<FaAngleDoubleRight />}
                onClick={handleAvancar}
                loadingText={"Continuando..."}
                usesLoading
                block
              />
            </Col>
          </Row>
        </>)}
    </>
  );
}
